<template>
  <a-card>
    <span slot="title" class="title">{{ `${titlepage.toUpperCase()} LIST` }}</span>
    <div slot="extra">
      <a-input-search
        placeholder="input search text"
        style="width: 300px"
        v-model="search"
      />
    </div>
    <a-tabs :activeKey="activetab" @change="handleTab">
      <a-tab-pane tab="BKK Release" key="release">
        <div class="loading" v-if="loading.release">
          <a-spin :spinning="loading.release" tip="Loading..."></a-spin>
        </div>
        <a-table
          v-else
          :columns="column_release"
          :dataSource="release_list"
          id="id_ep1"
          size="small"
          :pagination="pagination"
          bordered
          :scroll="{ x: 100 }"
        >
          <a
            slot="no"
            slot-scope="item"
            @click="handleLink(item.jenis, item.id)"
            >{{ item.no }}</a
          >
          <span slot="value" slot-scope="amount">
            <CurrencyJustified
              v-if="amount.value"
              :key="amount.key"
              :currencyValue="amount.currency"
              :valueNumber="amount.value"
            />
            <div v-else style="text-align:center;width:100%">-</div>
          </span>
          <span slot="update_by" slot-scope="item">
            <span v-if="item.tlc_updated">
              {{ item.tlc_updated }} /
              {{
                item.date_updated
                  ? moment(item.date_updated, getDateTimeStandartFormat).format(
                      getDefaultDateFormat
                    )
                  : "-"
              }}
            </span>
            <span v-else>
              -
            </span>
          </span>
          <span slot="no_bkk" slot-scope="item">
            <a v-if="item.bkk_id"
            @click="handleLink('bkk', item.bkk_id)"
            >{{ item.no_bkk }}</a
            >
            <span v-else>-</span>
          </span>
        </a-table>
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";
export default {
  name: "BKKRelease",
  data() {
    return {
      activetab: "release",
      typepage: "",
      titlepage: "",
      list_release: [],
      list_process: [],
      loading: {
        release: false,
        process: false,
      },
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 20,
        size: "small",
      },
      search: "",
    };
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getDateTimeStandartFormat",
      "getTypePage",
    ]),
    column_process() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "#",
          key: "number",
          dataIndex: "number",
          width: this.getscreen ? 20 : 50,
          align: "center",
        },
        {
          title: "No",
          width: this.getscreen ? 100 : 250,
          key: "no",
          scopedSlots: { customRender: "no" },
        },
        {
          title: "Description",
          key: "deskripsi",
          dataIndex: "deskripsi",
          width: this.getscreen ? 180 : 250,
        },

        {
          title: "Value",
          key: "value",
          width: this.getscreen ? 100 : 200,
          scopedSlots: { customRender: "value" },
        },
        {
          title: "Action",
          key: "centang",
          width: this.getscreen ? 50 : 100,
          align: "center",
          scopedSlots: { customRender: "centang" },
        },
      ];
      return kolom;
    },
    column_release() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "#",
          key: "number",
          dataIndex: "number",
          width: this.getscreen ? 20 : 50,
          align: "center",
        },
        {
          title: "No",
          width: this.getscreen ? 100 : 250,
          key: "no",
          scopedSlots: { customRender: "no" },
        },
        {
          title: "Description",
          key: "deskripsi",
          dataIndex: "deskripsi",
          width: this.getscreen ? 180 : 250,
        },

        {
          title: "Value",
          key: "value",
          width: this.getscreen ? 100 : 200,
          scopedSlots: { customRender: "value" },
        },
        {
          title: "Update By",
          key: "update_by",
          width: this.getscreen ? 65 : 150,
          align: "center",
          scopedSlots: { customRender: "update_by" },
        },
        {
          title: "No BKK",
          key: "no_bkk",
          width: this.getscreen ? 65 : 150,
          align: "left",
          scopedSlots: { customRender: "no_bkk" },
        },
      ];
      return kolom;
    },
    release_list() {
      let output = this.list_release;

      if (this.search && this.activetab == "release") {
        output = output.filter(
          (obj) =>
            obj.no.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            moment(obj.date_updated)
              .format(this.getDefaultDateFormat)
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0 ||
            obj.tlc_updated.toLowerCase().indexOf(this.search.toLowerCase()) >=
              0 ||
            obj.value.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.deskripsi.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }
      return output;
    },
    process_list() {
      let output = this.list_process;

      if (this.search && this.activetab == "process") {
        output = output.filter(
          (obj) =>
            obj.no.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.value.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.deskripsi.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }
      return output;
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    moment,
    async fetchData() {
      if (this.activetab == "release") {
        this.loading.release = true;
      } 
      this.typepage = this.$route.meta.page_type;
      this.titlepage = this.$route.meta.page_title ? this.$route.meta.page_title : this.$route.meta.page_type;
      const release = axios({
        method: "get",
        url: this.$serviceUrl + "Bkk_release",
        params: {
          tab: "bkk release",
          jenis: this.typepage,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        console.log(err);
      });

      return await new Promise((resolve, reject) => {
        axios
          .all([
            release.catch((err) => {
              console.log(err);
              return null;
            }),
          ])
          .then((response) => {
            this.list_release = response[0] ? response[0].data.data : [];
            if (this.list_release.length > 0) {
              for (let index = 0; index < this.list_release.length; index++) {
                let col = [
                  {
                    ...this.list_release[index],
                    key: "b" + (index + 1),
                    number: index + 1,
                  },
                ];
                this.list_release[index] = col[0];
              }
            }
            this.loading.release = false;
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    handleTab(val) {
      this.activetab = val;
      this.search = "";
      if (this.activetab == "release") {
        this.loading.release = true;
      } 
      this.fetchData();
    },
    handleLink(jenis, id_) {
      let manifest = "";
      if (jenis == "pi") {
        manifest = "PiManifest";
      } else if (jenis == "umpp") {
        manifest = "UmppManifest";
      } else if (jenis == "umpd") {
        manifest = "umpd_manifest";
      } else if (jenis == "klaimpd") {
        manifest = "manifestKlaimPd";
      } else if (jenis == "klaimpp") {
        manifest = "manifestKlaimPp";
      } else if (jenis == "klaimdirektur") {
        manifest = "manifestDirectur";
      } else if (jenis == "bkk") {
        manifest = "bkkManifestAcc";
      } else if (jenis == "klaim_cc") {
          manifest = "manifestKlaimCC";
        } else if (jenis == "klaim_cc_pp") {
          manifest = "manifestKlaimCCPp";
        } else if (jenis == "klaim_cc_pd") {
          manifest = "manifestCCKlaimPd";
      } else {
        manifest = "lapUmppManifest";
      }
      const route = this.$router.resolve({
        name: manifest,
        params: { id: id_ },
      });
      window.open(route.href, "_blank");
    },
    changeActionItem(item) {
      axios({
        method: "post",
        url: this.$serviceUrl + "bkk_release",
        processData: false,
        data: {
          tlc: this.getAuth.username,
          jenis_transaksi: this.typepage,
          id_transaksi: item.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.displayMessage("success-edit");
          Event.$emit("trigfetchnotif", true);
          this.fetchData();
          this.activetab = "release";
        })
        .catch((err) => {
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error", responses);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.title {
  text-transform: capitalize;
}
</style>
